<template>
  <router-view/>
</template>

<script>
import heartbeatService from '@/services/heartbeatService'
import authService from '@/services/authService'

export default {
  name: 'App',
  
  mounted() {
    // Ha már be van jelentkezve, indítsuk el a heartbeat service-t
    if (authService.isAuthenticated()) {
      heartbeatService.start()
    }
    
    // Router referencia beállítása a heartbeat service számára
    window.router = this.$router
  },
  
  beforeUnmount() {
    heartbeatService.stop()
  }
}
</script>

<style>
</style>
